<template>
    <form class="ListSearch" @submit.prevent="onInput">
        <input
            type="text"
            class="ListSearch-text"
            placeholder="검색어를 입력하세요"
            v-model="searchData"
            id="search-bar"
        >

        <button
            type="submit"
            class="ListSearch-submit"
        >
            <span class="ab-text">검색하기</span>
        </button>
    </form>
</template>

<script>
export default {
    name: 'ListSearch',

    data() {
        return {
            searchData: ''
        };
    },

    methods: {
        onInput() {
            const keyword = this.searchData.trim();

            this.$emit("searchData", keyword);

            // 검색 후 입력창 비우기
            this.searchData = '';
        }
    }
}
</script>